import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// interfaces
import { ICatalogService } from '../../../shared/interfaces/catalog';

// models
import { ApplicationSettings } from '../../../shared/models/application-settings';
import { Catalog, CatalogsRequest } from '../../../shared/models/catalog';
import { SupplierPublish } from '../../../shared/models/supplier-publish';

// services
import { WebApiService } from '../../../shared/services/web-api.service';


@Injectable()
export class CatalogService implements ICatalogService {

  private apiPath: string;
  private buyerId: number;

  constructor(private appSettings: ApplicationSettings, private webApiService: WebApiService) {
    this.apiPath = this.appSettings.adminApi + 'buyerlevel';
  }

  setId(id: number){
    this.buyerId = id;
  }
  
  //ICatalogService

  getAllSupplyCatalogs(): Observable<Array<Catalog>> {
    return this.webApiService.getList(`${this.apiPath}/${this.buyerId}/catalog`);
  }

  getAllSupplyAndForecastCatalogsForReports(auctionClusterId: number): Observable<Array<Catalog>> {
    return this.webApiService.getList(`${this.apiPath}/${this.buyerId}/auctioncluster/${auctionClusterId}/catalog/all`);
  }
    
  getAllForecastCatalogs(auctionClusterId: number): Observable<Array<Catalog>> {
    return;
  }

  setSupplyEditorMode(cookieService: any): boolean {
    return;
  }

  publishSupplierLots(auctionId: number, catalogId: number, suppliers: SupplierPublish): Observable<any> {
    return;
  }
  
  getAllCatalogsWithSupplyOrTransactions(catalogsRequest: CatalogsRequest): Observable<Array<Catalog>> {
    return this.webApiService.save(`${this.apiPath}/${this.buyerId}/catalog`, catalogsRequest);
  }
}
